import { render } from "./report_dashboard.vue?vue&type=template&id=38412050&scoped=true"
import script from "./report_dashboard.js?vue&type=script&lang=js"
export * from "./report_dashboard.js?vue&type=script&lang=js"

import "./report_dashboard.vue?vue&type=style&index=0&id=38412050&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38412050"]])

export default __exports__